import { render, staticRenderFns } from "./CardContentDefaultPublicIncomeStatement.vue?vue&type=template&id=87d9456a&scoped=true&"
import script from "./CardContentDefaultPublicIncomeStatement.vue?vue&type=script&lang=js&"
export * from "./CardContentDefaultPublicIncomeStatement.vue?vue&type=script&lang=js&"
import style0 from "./CardContentDefaultPublicIncomeStatement.vue?vue&type=style&index=0&id=87d9456a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d9456a",
  null
  
)

export default component.exports